import React from 'react';
import styled from '@emotion/styled';

interface Props {
  dark?: boolean;
  isHead?: boolean;
  children?: React.ReactNode;
}

const Component = styled.tr<{
  dark?: boolean;
  isHead?: boolean;
}>`
  vertical-align: middle;
  outline: 0;
  background-color: ${(props) =>
    props.dark ? 'var(--colorBlueGray1000)' : 'rgba(255, 255, 255, 0.08)'};
  ${(props) =>
    props.dark &&
    `
    border-bottom: 1px solid var(--colorBlueGray600);

    &:last-child {
      border-bottom: ${!props.isHead && 'none'};
    }
  `}
`;

const TableRow: React.FC<Props> = (props) => {
  return <Component {...props} />;
};

export default TableRow;
